import { environment } from "./../../../environments/environment";
import { Component, OnInit } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ourClientsService } from "src/services/our-clients/our-clients";
import { Inject } from '@angular/core';
@Component({
  selector: "our-clients",
  templateUrl: "./our-clients.component.html",
  styleUrls: ["./our-clients.component.css"],
})
export class OurClientsComponent implements OnInit {
  data: any;
  URL = environment.PhotoPath;
  customOptions: OwlOptions = {
    loop: true,
    nav: false,
    dots: true,
    autoplay: true,
    autoplayHoverPause: true,
    items: 3,
    responsive : {
      0 : {
        items : 1
      },
      768 : {
        items : 2
      },
      992 : {
        items : 3
      }
  }
  };

  constructor(private service: ourClientsService) {}

  ngOnInit(): void {
    this.get();
  }


  get() {
    this.service.get_ourClients().subscribe({
      next: (data: any) => {
        this.data = data.data;
      },
    });
  }

  
}